// Лупа шапки вкладки (AppBar) по умолчанию ведёт на общий экран поиска. Экран вкладки может перехватить её своим
// режимом поиска на месте (поиск «Избранного», HQ-1058): регистрирует обработчик, пока смонтирован.
import { useEffect } from 'react';

type Handler = (endpoint: string | undefined) => void;
let handler: Handler | null = null;

/** Лупа нажата: обработчик экрана, если есть, иначе запасной путь (общий поиск). */
export function runSearch(endpoint: string | undefined, fallback: () => void): void {
  if (handler) handler(endpoint); else fallback();
}

/** Поставить обработчик лупы; возвращает снятие (снимает только свой). */
export function setSearchHandler(next: Handler): () => void {
  handler = next;
  return () => { if (handler === next) handler = null; };
}

/** Перехватить лупу шапки, пока экран смонтирован. */
export function useSearchOverride(next: Handler): void {
  useEffect(() => setSearchHandler(next), [next]);
}
